/**
 * @description Hook utilizado para realizar operações relacionadas às análises de local realizadas nos exames de local
 * @author Diego Sabino Amorim de Araújo
 * @file useAnaliseLocalService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import { criarAlerta } from 'actions'
import { useFetch } from './useFetch'

export const useAnaliseLocalService = () => {
  const dispatch = useDispatch()
  const fetch = useFetch()

  const getAnaliseLocalDeExame = async (idExame, idLocal, setAnaliseLocal, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const response = await fetch.get(`/analiseLocal/deExame/${idLocal}/${idExame}`)
    setAnaliseLocal(response.data.analiseLocal)
    if (setProcessando) setProcessando(false)
  }

  const cadastrarAnaliseLocal = async (dados, setAnaliseLocal, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const response = await fetch.post(`/analiseLocal`, dados)
    setAnaliseLocal(response.data.analiseLocal)
    if (setProcessando) setProcessando(false)
    dispatch(criarAlerta(response))
  }

  const editarAnaliseLocal = async (id, dados, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const response = await fetch.put(`/analiseLocal/${id}`, dados)
    if (setProcessando) setProcessando(true)
    dispatch(criarAlerta(response))
  }

  const setarAnaliseLocalDeExameRealizado = async (
    idLocal,
    idExameRealizado,
    values,
    setProcessando
  ) => {
    try {
      if (setProcessando) setProcessando(true)
      const dados = {
        ...values,
      }
      const response = await fetch.postOpen(
        `/analiseLocal/setar/deExame/${idLocal}/${idExameRealizado}`,
        dados
      )
      return response.data.analiseLocal
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    getAnaliseLocalDeExame,
    cadastrarAnaliseLocal,
    editarAnaliseLocal,
    setarAnaliseLocalDeExameRealizado,
  }
}
